/* Holy Smoke — Long Fill Auto Builder (FINAL)
   - Adds selected Long Fill flavour + correct nic shots split + VG top-up booster.
   - Allows customer choice:
       Auto Build (Recommended)  -> adds flavour + shots + VG top-up
       I’ll mix it myself        -> adds flavour only (normal Shopify add)

   YOUR RULES (shots are 10ml @ 18mg/ml):
   Bottle 120ml:
     - Tight draw (mtl):     2x PG, rest VG
     - Slightly airy (rdtl): 1x PG, rest VG
     - Big clouds (dtl):     all VG
   Bottle 60ml:
     - Tight draw (mtl):     1x PG, rest VG
     - Slightly airy (rdtl): 1x PG, rest VG
     - Big clouds (dtl):     all VG

   Top-up: ALWAYS VG (uses boosters.vg_120)
*/

(function () {
  const GLOBAL_LOCK_KEY = "__hs_longfill_builder_global_lock__";

  function $(sel, root = document) {
    return root.querySelector(sel);
  }

  function $all(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function readCFG() {
    const cfgEl = document.getElementById("hs_builder_cfg");
    if (!cfgEl) {
      console.warn("[HS Builder] Missing #hs_builder_cfg. (Liquid inject not present)");
      return null;
    }

    try {
      const CFG = JSON.parse(cfgEl.textContent || "{}");
      return {
        nic: {
          freebase_pg: Number(CFG?.nic?.freebase_pg || 0),
          freebase_vg: Number(CFG?.nic?.freebase_vg || 0),
          salt_pg: Number(CFG?.nic?.salt_pg || 0),
          salt_vg: Number(CFG?.nic?.salt_vg || 0),
        },
        boosters: {
          vg_120: Number(CFG?.boosters?.vg_120 || 0),
          pg_120: Number(CFG?.boosters?.pg_120 || 0), // not used (top-up is always VG)
        },
      };
    } catch (e) {
      console.error("[HS Builder] cfg JSON parse failed.", e);
      return null;
    }
  }

  function findMainProductForm() {
    // Dawn can have multiple forms (sticky, etc.). Prefer the one inside product-info.
    const preferred = document.querySelector("product-info product-form form[action^='/cart/add']");
    if (preferred) return preferred;

    const any = document.querySelector("product-form form[action^='/cart/add'], form[action^='/cart/add']");
    return any || null;
  }

  function findScopeForForm(form) {
    return (
      form.closest("product-info") ||
      form.closest(".product") ||
      form.closest("section") ||
      document
    );
  }

  function getSelectedVariantLabel(scope) {
    // Radios / pills
    const checkedRadio =
      scope.querySelector(".variant-picker input[type='radio']:checked") ||
      scope.querySelector("fieldset input[type='radio']:checked") ||
      scope.querySelector("input[type='radio']:checked");

    if (checkedRadio) {
      const lbl =
        scope.querySelector(`label[for="${checkedRadio.id}"]`) ||
        checkedRadio.closest("label");
      const t = (lbl ? lbl.textContent : checkedRadio.value || "").trim();
      if (t) return t;
    }

    // Dropdown
    const selectOpt =
      scope.querySelector("select[name^='options'] option:checked") ||
      scope.querySelector("select option:checked");

    return selectOpt ? (selectOpt.textContent || "").trim() : "";
  }

  function isLongFill(label) {
    return /long\s*fill/i.test(label || "");
  }

  function parseBottleSize(label) {
    const s = (label || "").toLowerCase();
    if (s.includes("60ml")) return 60;
    if (s.includes("120ml")) return 120;

    const nums = (s.match(/\d+/g) || []).map(Number);
    if (nums.includes(60)) return 60;
    if (nums.includes(120)) return 120;
    return 0;
  }

  // 10ml @ 18mg/ml shot = 180mg nicotine total
  function nicShotsNeeded(bottleML, targetMgML) {
    if (!bottleML || !targetMgML) return 0;
    const mgPerShotInBottle = 180 / bottleML; // 60ml => 3mg, 120ml => 1.5mg
    return Math.ceil(targetMgML / mgPerShotInBottle);
  }

  // YOUR FINAL RULES IMPLEMENTED EXACTLY
  function splitShotsByRules(totalShots, feel, bottleML) {
    let pg = 0;
    let vg = 0;

    if (totalShots <= 0) return { pg: 0, vg: 0 };

    if (feel === "dtl") {
      // Big clouds: all VG
      return { pg: 0, vg: totalShots };
    }

    if (feel === "rdtl") {
      // Slightly airy: 1x PG, rest VG (both 60 and 120)
      pg = Math.min(1, totalShots);
      vg = totalShots - pg;
      return { pg, vg };
    }

    // Tight draw (mtl):
    // 60ml: 1x PG, rest VG
    // 120ml: 2x PG, rest VG
    const pgCap = (bottleML === 120) ? 2 : 1;
    pg = Math.min(pgCap, totalShots);
    vg = totalShots - pg;
    return { pg, vg };
  }

  function nicVariantId(HS, nicType, carrier) {
    if (nicType === "salt") {
      return carrier === "pg" ? HS.nic.salt_pg : HS.nic.salt_vg;
    }
    return carrier === "pg" ? HS.nic.freebase_pg : HS.nic.freebase_vg;
  }

  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("Cart add failed. " + txt);
    }

    return res.json();
  }

  // ---------------- UI Injection ----------------
  function injectUI() {
    if (document.getElementById("hs_builder")) return;

    const HS = readCFG();
    if (!HS) return;

    const form = findMainProductForm();
    if (!form) return;

    const atcButton =
      form.querySelector("button[type='submit']") ||
      form.querySelector("[name='add']");

    if (!atcButton) return;

    const box = document.createElement("div");
    box.id = "hs_builder";
    box.dataset.feel = "mtl"; // single source of truth for feel
    box.style.cssText =
      "margin-top:14px;padding:14px;border:1px solid rgba(0,0,0,.10);border-radius:12px;display:none;";

    box.innerHTML = `
      <div style="font-weight:700; margin-bottom:10px;">Make it ready to vape</div>

      <div style="margin-bottom:12px; display:flex; gap:16px; align-items:center; flex-wrap:wrap;">
        <label style="font-size:13px; cursor:pointer;">
          <input type="radio" name="hs_mode" value="auto" checked />
          Auto Build (Recommended)
        </label>
        <label style="font-size:13px; cursor:pointer;">
          <input type="radio" name="hs_mode" value="manual" />
          I’ll mix it myself
        </label>
      </div>

      <div class="hs_auto_only">
        <div style="display:flex; gap:10px; flex-wrap:wrap; margin-bottom:12px;">
          <button type="button" class="hs-feel" data-feel="mtl">Tight draw</button>
          <button type="button" class="hs-feel" data-feel="rdtl">Slightly airy</button>
          <button type="button" class="hs-feel" data-feel="dtl">Big clouds</button>
        </div>

        <div style="display:flex; gap:12px; flex-wrap:wrap; align-items:end;">
          <div>
            <label style="display:block; font-size:13px; margin-bottom:6px;">Nicotine</label>
            <select id="hs_nic_type" style="min-width:190px; padding:10px; border-radius:10px;">
              <option value="salt">Smooth (Nic Salt)</option>
              <option value="freebase">Classic (Freebase)</option>
            </select>
          </div>

          <div>
            <label style="display:block; font-size:13px; margin-bottom:6px;">Strength</label>
            <select id="hs_nic_mg" style="min-width:120px; padding:10px; border-radius:10px;">
              <option value="0">0mg</option>
              <option value="3">3mg</option>
              <option value="6" selected>6mg</option>
              <option value="9">9mg</option>
              <option value="12">12mg</option>
            </select>
          </div>
        </div>

        <div id="hs_summary" style="margin-top:12px; font-size:14px; opacity:.9;"></div>

        <div style="margin-top:10px; font-size:12px; opacity:.65;">
          Auto-adds nicotine shots + VG top-up.
        </div>
      </div>
    `;

    atcButton.parentElement.insertBefore(box, atcButton);

    const scope = findScopeForForm(form);

    const feelBtns = $all(".hs-feel", box);
    const nicTypeSel = $("#hs_nic_type", box);
    const nicMgSel = $("#hs_nic_mg", box);
    const summary = $("#hs_summary", box);
    const autoOnlyWrap = $(".hs_auto_only", box);

    function getMode() {
      const modeEl = box.querySelector("input[name='hs_mode']:checked");
      return modeEl ? modeEl.value : "auto";
    }

    function styleFeelButtons(activeFeel) {
      feelBtns.forEach((b) => {
        b.style.cssText =
          "padding:10px 12px;border-radius:999px;border:1px solid rgba(0,0,0,.15);background:#fff;cursor:pointer;";
        b.setAttribute("aria-pressed", b.dataset.feel === activeFeel ? "true" : "false");
        if (b.dataset.feel === activeFeel) {
          b.style.borderColor = "#000";
          b.style.fontWeight = "700";
        }
      });
      box.dataset.feel = activeFeel;
    }

    function getFeel() {
      return box.dataset.feel || "mtl";
    }

    function render() {
      const label = getSelectedVariantLabel(scope);
      const show = isLongFill(label);

      box.style.display = show ? "block" : "none";
      if (!show) return;

      const mode = getMode();
      if (autoOnlyWrap) autoOnlyWrap.style.display = (mode === "manual") ? "none" : "block";
      if (mode === "manual") return;

      const bottle = parseBottleSize(label);
      const feel = getFeel();
      const mg = Number(nicMgSel?.value || 0);
      const totalShots = nicShotsNeeded(bottle, mg);
      const split = splitShotsByRules(totalShots, feel, bottle);

      if (summary) {
        summary.textContent = `Auto-build: ${bottle}ml long fill • ${mg}mg • shots PG:${split.pg} / VG:${split.vg} • top-up: VG`;
      }
    }

    // Defaults
    styleFeelButtons("mtl");
    render();

    // Events
    scope.addEventListener("change", render);
    form.addEventListener("change", render);

    feelBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        styleFeelButtons(btn.dataset.feel);
        render();
      })
    );

    box.addEventListener("change", (e) => {
      const t = e.target;
      if (t && t.name === "hs_mode") render();
    });

    if (nicMgSel) nicMgSel.addEventListener("change", render);
    if (nicTypeSel) nicTypeSel.addEventListener("change", render);
  }

  // ---------------- Single global submit handler (CAPTURE) ----------------
  async function onSubmitCapture(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("form[action^='/cart/add']")) return;

    const HS = readCFG();
    if (!HS) return;

    const scope = findScopeForForm(form);
    const label = getSelectedVariantLabel(scope);
    if (!isLongFill(label)) return; // only intercept Long Fill

    // Kill all other submit handlers to prevent double-add
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Global lock prevents two different forms (sticky + main) both firing
    if (window[GLOBAL_LOCK_KEY]) return;
    window[GLOBAL_LOCK_KEY] = true;

    try {
      const variantIdInput = $("input[name='id']", form);
      const mainVariantId = Number(variantIdInput?.value || 0);
      const bottle = parseBottleSize(label);

      const box = document.getElementById("hs_builder");
      const modeEl = box ? box.querySelector("input[name='hs_mode']:checked") : null;
      const mode = modeEl ? modeEl.value : "auto";

      // Manual mode: let Shopify add ONLY the flavour
      if (mode === "manual") {
        window[GLOBAL_LOCK_KEY] = false;
        form.submit();
        return;
      }

      const feel = (box?.dataset?.feel) || "mtl";
      const nicTypeSel = box ? $("#hs_nic_type", box) : null;
      const nicMgSel = box ? $("#hs_nic_mg", box) : null;

      const nicType = (nicTypeSel?.value) || "salt";
      const mg = Number(nicMgSel?.value || 0);

      if (!mainVariantId || !bottle) {
        window[GLOBAL_LOCK_KEY] = false;
        form.submit();
        return;
      }

      const items = [];

      // 1) Add the selected flavour (ONCE)
      items.push({
        id: mainVariantId,
        quantity: 1,
        properties: {
          _holy_smoke: "auto-build",
          _size_ml: String(bottle),
          _feel: feel,
          _nic_type: nicType,
          _nic_mg: String(mg),
        },
      });

      // 2) Add shots using YOUR rules
      if (mg > 0) {
        const totalShots = nicShotsNeeded(bottle, mg);
        const { pg, vg } = splitShotsByRules(totalShots, feel, bottle);

        if (pg > 0) {
          const idPG = nicVariantId(HS, nicType, "pg");
          if (!idPG) console.error("[HS Builder] Missing PG nic variant id", { nicType, HS });
          else items.push({
            id: idPG,
            quantity: pg,
            properties: { _holy_smoke_for: String(mainVariantId), _carrier: "PG" },
          });
        }

        if (vg > 0) {
          const idVG = nicVariantId(HS, nicType, "vg");
          if (!idVG) console.error("[HS Builder] Missing VG nic variant id", { nicType, HS });
          else items.push({
            id: idVG,
            quantity: vg,
            properties: { _holy_smoke_for: String(mainVariantId), _carrier: "VG" },
          });
        }
      }

      // 3) VG top-up ALWAYS
      if (!HS.boosters.vg_120) {
        console.error("[HS Builder] Missing boosters.vg_120 metafield", HS);
      } else {
        items.push({
          id: HS.boosters.vg_120,
          quantity: 1,
          properties: { _holy_smoke_for: String(mainVariantId), _topup: "VG" },
        });
      }

      await addItems(items);
      window.location.href = "/cart";
    } catch (err) {
      console.error("[HS Builder] failed", err);
      window[GLOBAL_LOCK_KEY] = false;
      form.submit(); // fallback
    }
  }

  // ---------------- Boot ----------------
  function boot() {
    injectUI();
    if (!document.documentElement.dataset.hsBuilderSubmitBound) {
      document.documentElement.dataset.hsBuilderSubmitBound = "1";
      // Capture phase submit listener = prevents double add
      document.addEventListener("submit", onSubmitCapture, true);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:reorder", boot);
  document.addEventListener("shopify:section:select", boot);
})();